/* eslint-disable react/no-multi-comp */
import React from 'react';
import styles from './Faqs.scss';
import { PageHeader } from '../../components/shared';
import cx from 'classnames';
import shippingPdf from '../../files/Suite-Shipping-Request-Form.pdf';

class Panel extends React.Component {
  constructor(props) {
    super(props);
    this.state = { height: 0 };
    this.panelRef = React.createRef();
  }

  componentDidMount() {
    // Wait a bit so the content renders before measuring height.
    setTimeout(() => {
      const el = this.panelRef.current;
      // Use the CSS module class name for panel__inner
      const inner = el.querySelector(`.${styles.panel__inner}`);
      const height = inner ? inner.scrollHeight : 0;
      this.setState({ height });
    }, 333);
  }

  render() {
    const { label, content, activeTab, index, activateTab } = this.props;
    const { height } = this.state;
    const isActive = activeTab === index;
    const innerStyle = {
      height: `${isActive ? height : 0}px`,
    };

    return (
      <div
        className={cx(styles.panel, { [styles.active]: isActive })}
        role="tabpanel"
        ref={this.panelRef}
      >
        <button
          className={styles.panel__label}
          role="tab"
          onClick={activateTab}
        >
          {label}
          <svg xmlns="http://www.w3.org/2000/svg" className={styles.close}>
            <g>
              <path d="M.887 27.678L27.677.887l2.436 2.435-26.79 26.791z" />
              <path d="M3.322.887l26.791 26.79-2.435 2.436L.887 3.323z" />
            </g>
          </svg>
        </button>
        <div className={styles.panel__inner} style={innerStyle}>
          <p
            dangerouslySetInnerHTML={{ __html: content }}
            className={styles.panel__content}
          />
        </div>
      </div>
    );
  }
}

class Accordion extends React.Component {
  constructor(props) {
    super(props);
    this.state = { activeTab: 0 };
  }

  activateTab = index => {
    this.setState(prev => ({
      activeTab: prev.activeTab === index ? -1 : index,
    }));
  };

  render() {
    const { panels } = this.props;
    const { activeTab } = this.state;
    return (
      <div className={styles.accordion} role="tablist">
        {panels.map((panel, index) => (
          <Panel
            key={index}
            activeTab={activeTab}
            index={index}
            label={panel.label}
            content={panel.content}
            activateTab={() => this.activateTab(index)}
          />
        ))}
      </div>
    );
  }
}

const panelsData = [
  {
    label: 'How and when do I order catering:',
    content:
      'F&B is included with all suites at U.S. Bank Stadium for home Vikings games. Catering deadlines for home Vikings games are due nine (9) days before the home game. Orders can be placed in your Aramark account found in your Vikings Premium portal. Norseman Lounges do not have customizable F&B. For more information about placing an order or making adjustments, please contact Nicole Kozitza with Aramark: <a href="mailto:Kozitza-Nicole@aramark.com">Kozitza-Nicole@aramark.com</a>',
  },
  {
    label: 'Can I order food and beverages from my suite on game day?',
    content:
      'Yes. Each suite is serviced by a shared suite attendant. In-game food and drink orders can be placed via the attendant.',
  },
  {
    label: 'Do I tip our suite attendant?',
    content: 'Yes, gratuity is customary.',
  },
  {
    label: 'Alcohol Policy',
    content:
      "Guests must be 21 years of age or older and present a valid Driver's License (not vertical), a State Identification Card, a Passport, or a Military Identification Card to purchase beverages containing alcohol.",
  },
  {
    label: 'Can I purchase additional tickets to my suite?',
    content: `Additional tickets otherwise known as standing room only tickets (SROs) are available for purchase via your Vikings Ticketmaster account. For step-by-step instructions, please see here:
      <ul>
      <li>Select the "My Tickets" tab at the top left of your screen. </li>
<li>Navigate to the "My Events" tab and select "View Event Details" for the specific game you would be like to add SRO's to. </li>
<li>At the top right corner, you will need to select a "More" button. </li>
<li>From there is will direct you to claim and purchase 2 SRO tickets for $325 per ticket.</li>
      </ul>
      If you have further questions, please reach out to your premium experience representative. 

      `,
  },
  {
    label: 'Can I get guest passes for my suite?',
    content:
      'Each home Viking game, complimentary guest passes will be loaded onto your Vikings Ticketmaster account. Guest passes are not a ticket, and do not allow access to the stadium. You must have a valid game ticket with your guest pass for home games. Guest passes are not available for concerts or other events at U.S. Bank Stadium.',
  },
  {
    label:
      'How do we secure our suite for concerts and events at U.S. Bank Stadium?',
    content:
      'Suites with clear sightlines to U.S. Bank Stadium may be secured through the Events tab in your portal. Suites with obstructed or impaired views will instead be offered presale access to club tickets in lieu of suite access.',
  },
  {
    label: 'Is there a child ticket policy?',
    content:
      'All guests who have had their 2nd birthday MUST have a ticket to enter an event at U.S. Bank Stadium. Some U.S. Bank Stadium events will require all attendees, regardless of age, to present a ticket for entry.\nFor Minnesota Vikings football games, (1) child under who is less than 2 years old and less than 36 inches tall will be granted complimentary access with (1) ticketed adult. This child will be issued a wristband upon entry at the gates. The wristband must be worn while inside the stadium. Children with wristbands must stay seated on the lap of the adult and must not occupy another person’s seat.',
  },
  {
    label: 'When does my suite open, and how long can we stay post game?',
    content:
      'Suite access opens two (2) hours prior to kickoff and guests can stay in their suite up to one (1) hour post the conclusion of the game.',
  },

  {
    label: 'If we have an issue with our suite on gameday, who can I contact?',
    content: 'Please contact your Vikings premium representative.',
  },
  {
    label: 'What am I permitted to bring into U.S. Bank Stadium?',
    content:
      "U.S. Bank Stadium adheres to the NFL's Clear Bag policy for all stadium events. For additional rules, please contact a representative from the Minnesota Vikings Premium Services team.",
  },

  {
    label: 'How do I ship items to our suite ahead of time?',
    content: `To ship items to your suite, see the <a href="${shippingPdf}" target="_blank">shipping form</a>.`,
  },
  {
    label: 'How can I report an unruly fan?',
    content:
      'Should you observe any violations, please text "VIKES" the issue and location to code 612-777-8977. You may also contact an usher or security officer, or stop by the nearest Fan Services location, to report the problem. Standard text message rates and other charges may apply.',
  },
  {
    label: 'When is the Northern Lights Package unavailable?',
    content: `The Omni Vikings Lake Hotel Northern Lights Package will not be available for the Minnesota Vikings home game on Christmas Day. If you have any questions, please don't hesitate to reach out to your account representative.`,
  },
];
const Faqs = () => {
  return (
    <div className={styles.faqs}>
      <PageHeader title="FAQS" />
      <div className={styles.faqs__content}>
        <Accordion panels={panelsData} />
      </div>
    </div>
  );
};

export default Faqs;
